import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Image, Typography, Row, Col, Card } from 'antd';
import { UserMigrationDetails } from 'all-in-one-shared-api/dist/apis/user/usePatchExistingUser';
import generateKey from 'utils/generateKey';
import { useInterval } from 'hooks/useInterval';
import type { InputRef } from 'antd';

// import mobileIcon from 'assets/images/mobile-icon.svg';
import mobileIcon from 'assets/images/neutral-1.svg';
import emailIcon from 'assets/images/Group 3.svg';
// import { RegistrationFlowContext } from 'contexts/registration';
import styled from 'styled-components';
// import {
//   Card,
//   // Container,
//   InvalidTextMsg,
//   // OtpInputField,
//   ResendCaptchaSection,
//   SubTitle,
//   OtpInputContainer,
//   OtpInputWrapper,
//   // OtpInput,
// } from
import { getConfig } from 'configs';
// import moment from 'moment';
// import { setErrorCodeFun } from '../../../../utils/setErrorCodeFun/setErrorCodeFun';
// import { SessionStorageKey, sessionStorageService } from '../../../../utils/SessionStorageService';
// import { useRegistrationStateQuery } from '../../../../hooks/useRegistrationStateQuery';
// import GoogleCaptcha from '../../../../components/googleCaptcha';
// import { getBirthdayString } from 'utils/registration';
// import { useKeycloakReady } from 'hooks';
import {
  // ApiFetcherError,
  useRequestOtp,
  useValidateOtp,
  useEmailOtp,
  useEmailOtpValidate,
  useAddLifePolicy,
  // useRegisterEB,
  // useLifeUserRegister,
  // useRegister,
  // usePatchExistingUser,
} from 'all-in-one-shared-api';
import './otp.less';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { osName, osVersion } from 'react-device-detect';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { InvalidTextMsg, ResendCaptchaSection, SubTitle } from 'pages/registration/otp-verification/styledComponents';
import { NewInput } from 'pages/life/registration/otp-verification/styledComponents';
import GoogleCaptcha from 'components/googleCaptcha';
import jwtDecode from 'jwt-decode';
const { Title, Text, Link } = Typography;
import { useKeycloakReady } from 'hooks/useKeycloakReady';

const RESEND_COUNTDOWN_PERIOD = 60;

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

interface LocationState extends UserMigrationDetails {
  prevPath?: string;
  saveTodb?: boolean;
  email?: string;
  type?: string;
  selfDefinedLoginId?: string;
  password?: string;
  policyNumber?: string;
  memberType?: string;
  dob?: string;
  pwd?: string;
  birthDate: string;
  memberId?: string;
  identityNo: string;
  areaCode: string;
}
type LifeCardPropList = {
  color?: string;
  arrow?: true;
  stateCode?: string;
  policynumber?: string;
  title?: string;
  name?: string;
  policyTitle?: string;
  alertsType?: string;
  alertsCode?: string;
  dueDate?: string;
  productCategory?: string;
  productCategoryUrl?: string;
  productCategoryEn?: string;
  productCategoryTC?: string;
  companyCode?: string;
  productName?: string;
  productNameTc?: string;
  policyStatusCode?: string;
  policyStatus?: string;
  policyStatusTc?: string;
  colour?: string;
  alertStateCode?: string;
  alertState?: string;
  alertStateTc?: string;
  policyNumber?: string;
  insuredName?: string;
  premiumDueDate?: string;
  salesUnitCode?: string;
  memberId?: string;
  effectiveStart?: string;
  effectiveEnd?: string;
}[];
const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
export const OtpVerificationPageLife = (): JSX.Element => {
  // const [resendCountdown, setResendCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [otpArray, setOtpArray] = useState('');
  const [isAllowEdit, setIsAllowEdit] = useState(false);
  const { keycloak } = useKeycloak();
  const { t, i18n } = useTranslation();
  const { tokenParsed } = useKeycloakReady();

  const navigate = useNavigate();
  // const registrationState = useRegistrationStateQuery();
  // const [otpInput, setOtpInput] = useState("");
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [requestOtpCount, setRequestOtpCount] = useState(0);
  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  // const [disabledVerification, setDisabledVerification] = useState(false);
  // const { state } = useContext(RegistrationFlowContext);
  const location = useLocation();
  const loginId = tokenParsed?.preferred_username;
  const [showTips, setShowTips] = useState(false);

  // const password = localStorage.getItem('password') ?? '';
  const {
    // loginId,
    mobile,
    email,
    countryCode,
    // type,
    // selfDefinedLoginId,
    // password,
    // policyNumber,
    // memberType,
    birthDate,
    identityNo,
    areaCode,
    // // pwd,
    // memberId,
  } = (location.state as LocationState) ?? {};

  // Note(Anson Kan): assuming `mobile` exists for the current user
  const mobileNumber = (countryCode ?? '') + (areaCode ?? '') + (mobile ?? '');
  const [key, setKey] = useState<string>('');
  // const {
  //   data: lifeRegisterResponse,
  //   error: lifeRegisterError,
  //   shouldFetch: shouldLifeRegister,
  // } = useLifeUserRegister(
  //   'life-user—register',
  //   state.identityNo ?? '',
  //   state.dob ? moment(state.dob).format('DD/MM/YYYY') : '',
  //   state.email ?? '',
  //   state.selfDefinedLoginId ?? '',
  //   state.confirmPassword ?? '',
  //   i18n.language,
  //   state.email ? '' : state.mobile ?? '',
  //   state.email ? '' : state.countryCode ?? '',
  // );
  // const {
  //   data: ebRegisterResponse,
  //   error: ebRegisterError,
  //   shouldFetch: shouldEBRegister,
  // } = useRegisterEB(
  //   'eb-user—register',
  //   policyNumber ?? '',
  //   memberId ?? '',
  //   birthDate ? moment(birthDate).format('DD/MM/YYYY') : '',
  //   email ?? '',
  //   selfDefinedLoginId ?? '',
  //   password ?? '',
  //   i18n.language,
  //   memberType ?? '',
  // );
  const {
    shouldFetch: AddLifePolicyFetch,
    data: AddLifePolicyData,
    error: AddLifePolicyError,
  } = useAddLifePolicy('useAddLifePolicy', keycloak.token as string, identityNo, birthDate);
  const { shouldFetch /*, isLoading */ } = useRequestOtp(key, loginId ?? '', mobileNumber, {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldFetch(false);
    },
    onError: (error) => {
      if (error) {
        shouldFetch(false);
        // const apiError = error as ApiFetcherError;
        // setErrorMsg(apiError.code ? apiError.code : error.message);
        const errorMessage = setErrorCodeFun(error.code, i18n.language);
        setErrorMsg(errorMessage ?? error.code ?? error.message);
      }
    },
  });
  const { shouldFetch: shouldEmailFetch /*, isLoading */ } = useEmailOtp(key, loginId ?? '', email ?? '', {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldEmailFetch(false);
    },
    onError: (error) => {
      if (error) {
        shouldEmailFetch(false);
        // const apiError = error as ApiFetcherError;
        // setErrorMsg(apiError.code ? apiError.code : error.message);
        const errorMessage = setErrorCodeFun(error.code, i18n.language);
        setErrorMsg(errorMessage ?? error.code ?? error.message);
      }
    },
  });

  const [validateKey, setValidateKey] = useState<string>('');
  const { shouldFetch: shouldEmailValidate /*, isLoading: isValidating */ } = useEmailOtpValidate(
    validateKey,
    loginId ?? '',
    otpArray,
    {
      shouldRetryOnError: false,
      onSuccess: (validateResponse) => {
        shouldEmailValidate(false);
        if (validateResponse) {
          if (validateResponse.success) {
            setErrorMsg(null);
            startUsing();
          } else {
            //光標移入第一個輸入框
            if (digit1InputRef.current) {
              digit1InputRef.current.focus();
            } else {
              console.error('digit1InputRef.current is null');
            }
            setOtpArray('');
            setErrorMsg(validateResponse.message);
          }
        }
      },
      onError: (error) => {
        if (error) {
          shouldEmailValidate(false);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );
  const [randoms, setMathRandom] = useState(Math.random());
  const { shouldFetch: shouldValidateOtp } = useValidateOtp('validateOtp' + randoms, loginId ?? '', otpArray, {
    shouldRetryOnError: false,
    onSuccess: (validateResponse) => {
      shouldValidateOtp(false);
      if (validateResponse) {
        if (validateResponse.success) {
          // shouldLifeRegister(true);
          startUsing();
        } else {
          //光標移入第一個輸入框
          if (digit1InputRef.current) {
            digit1InputRef.current.focus();
          } else {
            console.error('digit1InputRef.current is null');
          }
          setOtpArray('');
          setErrorMsg(validateResponse.message);
        }
      }
    },
    onError: (error) => {
      if (error) {
        shouldValidateOtp(false);
        const errorMessage = setErrorCodeFun(error.code, i18n.language);
        setErrorMsg(errorMessage ?? error.code ?? error.message);
      }
    },
  });

  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown >= 0 ? 1000 : null,
  );
  const digit1InputRef = useRef<InputRef>(null);

  // const resendCountdownIntervalID: NodeJS.Timeout | null = null;

  // const startResendCountdown = useCallback(() => {
  //   // 如果计时器已经存在，清除它
  //   if (resendCountdownIntervalID) {
  //     clearInterval(resendCountdownIntervalID);
  //   }

  //   // 设置新的计时器
  //   resendCountdownIntervalID = setInterval(() => {
  //     if (resendCountdown <= 0) {
  //       clearInterval(resendCountdownIntervalID as NodeJS.Timeout); // 强制断言类型为 NodeJS.Timeout
  //     } else {
  //       setResendCountdown(resendCountdown - 1);
  //     }
  //   }, 1000);
  // }, [resendCountdownIntervalID]);
  const handleResendOtp = () => {
    if (!showTips) setShowTips(true);
    if (requestOtpCount < 3) {
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }

    // setOtpInput("");
    setRequestOtpCount(requestOtpCount + 1);
    console.log('onPressResend()->');
    setKey(generateKey());

    setOtpArray('');
    setErrorMsg('life.register.resendOtp');
    if (digit1InputRef.current) {
      digit1InputRef.current.focus();
    }

    // setResendCountdown(RESEND_COUNTDOWN_PERIOD);
    // startResendCountdown();
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  };

  // useEffect(() => {
  //   startResendCountdown();

  //   return () => {
  //     if (resendCountdownIntervalID) {
  //       clearInterval(resendCountdownIntervalID);
  //     }
  //   };
  // }, [resendCountdownIntervalID, startResendCountdown]);
  useEffect(() => {
    if (requestOtpCount >= 3) {
      setIsShowCaptcha(true);
    }
  }, [requestOtpCount, setIsShowCaptcha]);
  useEffect(() => {
    setKey(generateKey());
    // 如果email存在，那麼shouldEmailFetch(true),否則shouldFetch(true)
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  }, [email, mobile, shouldEmailFetch, shouldFetch]);
  useEffect(() => {
    // if (!otpArray && errorMsg) {
    //   setErrorMsg('');
    // }
    // if (!otpArray || !/\d{6}/.test(otpArray)) {
    //   setDisabledVerification(true);
    // } else {
    //   setDisabledVerification(false);
    // }
  }, [errorMsg, otpArray]);
  const startUsing = async () => {
    AddLifePolicyFetch(true);
    // await loginWithRetry(loginId, password, 0);
    // 使用 replace 代替 reset，来模拟重置历史记录
    // navigate('/addConfirmEb', { replace: true });
  };
  /* eslint-disable */
  useEffect(() => {
    if (AddLifePolicyData) {
      refreshToken(AddLifePolicyData.lifeInsuranceList);
    }
  }, [AddLifePolicyData, AddLifePolicyError]);
  /* eslint-enable */
  const refreshToken = (lifeInsuranceList: LifeCardPropList) => {
    const { preferred_username }: { preferred_username: string } = jwtDecode(keycloak.token ?? '');
    keycloak
      .login({
        action: 'refresh_token',
        username: preferred_username,
        refreshToken: keycloak.refreshToken,
        device: osName,
        deviceVersion: osVersion,
      })
      .then(() => {
        keycloak.updateToken(-1);
        console.log(keycloak.tokenParsed, '刷新之后');

        navigate('/addConfirm', {
          state: {
            life: true,
            lifeCardData: lifeInsuranceList,
          },
          replace: true,
        });
      });
  };
  // const loginWithRetry = useCallback(
  //   (username: string, password: string, maxAttempts: number) => {
  //     return new Promise<void>((resolve, reject) => {
  //       const keycloakLogin = async (attempt = 1) => {
  //         try {
  //           await keycloak.login({
  //             username,
  //             password,
  //             device: osName,
  //             deviceVersion: osVersion,
  //           });
  //           resolve();
  //         } catch (error: unknown) {
  //           const errorMessage = error instanceof Error ? error.message : undefined;
  //           // console.log('loginWithRetry()->error from keycloak.login():', errorMessage);
  //           if ((errorMessage && !errorMessage.includes('auth error')) || attempt > maxAttempts) {
  //             reject(error);
  //           } else {
  //             setTimeout(() => keycloakLogin(attempt + 1), 500);
  //           }
  //         }
  //       };

  //       keycloakLogin();
  //     });
  //   },
  //   [keycloak],
  // );
  /* eslint-disable */
  // useEffect(() => {
  //   if (lifeRegisterResponse && !lifeRegisterError) {
  //     console.log('lifeRegisterResponse ------------------------', lifeRegisterResponse);
  //     // shouldLifeRegister(false);
  //     if (localStorage.getItem('registNum')) {
  //       localStorage.removeItem('registNum');
  //       startUsing();
  //     } else {
  //       localStorage.removeItem('registNum');
  //       navigate('/register/RegistrationConfirm', {
  //         replace: true,
  //         state: {
  //           lifeCardData: lifeRegisterResponse.lifeInsuranceList,
  //           life: true,
  //           username: state.selfDefinedLoginId,
  //           password: state.confirmPassword,
  //         },
  //       });
  //     }
  //   } else if (lifeRegisterError?.code) {
  //     // shouldLifeRegister(false);
  //     const errorMessage = setErrorCodeFun(lifeRegisterError.code, i18n.language);
  //     // if (!lifeRegisterError.message) {
  //     //   return setErrorMessage('common.error.generic');
  //     // }
  //     // if (lifeRegisterError.code === 'auth.register.unreg.dob') {
  //     //   return setErrorMessage('registration.error.invalidDob');
  //     // } else if (lifeRegisterError.code === 'auth.register.unreg.user') {
  //     //   return setErrorMessage('registration.error.userNotFound');
  //     // } else if (lifeRegisterError.code === 'dapi.user.account.exists') {
  //     //   return setErrorMessage('registration.error.existingUser');
  //     // }

  //     setErrorMsg(errorMessage);
  //   }
  // }, [lifeRegisterResponse, lifeRegisterError, i18n.language, navigate, shouldLifeRegister, state]);
  // useEffect(() => {
  //   if (ebRegisterResponse && !ebRegisterError) {
  //     console.log('ebRegisterResponse ------------------------', ebRegisterResponse);
  //     shouldEBRegister(false);
  //     startUsing();
  //   } else if (ebRegisterError?.code) {
  //     shouldEBRegister(false);
  //     const errorMessage = setErrorCodeFun(ebRegisterError.code, i18n.language);

  //     setErrorMsg(errorMessage);
  //   }
  // }, [ebRegisterResponse, ebRegisterError, i18n.language, navigate, shouldEBRegister, state]);
  const handleVerifyOtp = useCallback(() => {
    if (!/\d{6}/.test(otpArray)) {
      setErrorMsg(t('smsOtpVerification.code-not-found'));
      return;
    }

    setValidateKey(generateKey());
    if (email) {
      shouldEmailValidate(true);
    } else if (mobile) {
      shouldValidateOtp(true);
    }

    // mutateVerifyOtp();
  }, [otpArray, email, mobile, setErrorMsg, setValidateKey, shouldEmailValidate, shouldValidateOtp, t]);
  useEffect(() => {
    if (otpArray.length === 6) {
      setMathRandom(Math.random());
      handleVerifyOtp();
    }
  }, [otpArray, handleVerifyOtp]);
  useEffect(() => {
    if (errorMsg && errorMsg == 'smsOtpVerification.retry-limit-exceeded') {
      setIsAllowEdit(true);

      // setCountdown(30);
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
  }, [errorMsg]);
  useEffect(() => {
    if (countdown === 0) {
      setIsAllowEdit(false);
    }
  }, [countdown]);

  const onCaptchaSuccess = () => {
    setIsShowCaptcha(false);
  };

  const onCaptchaError = () => {
    setErrorMsg(t('login.error.captchaDigitError'));
  };
  const onOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    setOtpArray(e.target.value);
    setErrorMsg(null);
    // return (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const value = event.target.value;

    //   // 确保输入的是数字
    //   if (isNaN(Number(value))) {
    //     return;
    //   }

    //   const otpArrayCopy = [...otpArray]; // 创建otpArray的副本
    //   otpArrayCopy[index] = value;
    //   setOtpArray(otpArrayCopy);

    //   // 如果输入不为空，自动聚焦到下一个输入框
    //   if (value !== '') {
    //     const nextInputIndex = index + 1;
    //     if (nextInputIndex < otpArray.length) {
    //       (document.querySelectorAll('.single-digit-input')[nextInputIndex] as HTMLInputElement)?.focus();
    //     }
    //   }

    //   setErrorMsg(null);
    // };
  };
  function maskEmail(email: string) {
    if (!email) return '';
    // ???????????????
    const [username, domain] = email.split('@');
    // const [domains, coms,countrys] = domain.split('.');
    const domainList = domain.split('.');

    // ???????,???1???1?,???*??
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    if (domainList.length > 2) {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    } else {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    }
    // ??????????
  }
  function maskPhoneNumber(phoneNumber: string) {
    if (!phoneNumber) return '';
    // ???3???4?,???*??
    const visibleDigits = 2; // ????,??????????
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);

    // ?????*?????
    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);

    // ??????????
    return startDigits + maskedPart + endDigits;
  }
  return (
    <ResponsiveContainer>
      <div
        className="register_otp_wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          padding: '20px',
        }}
      >
        <Card style={{ border: 0, width: '100%', maxWidth: '400px' }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <Space align="center" direction="vertical"> */}
              <Title level={3} style={{ marginTop: '30px', fontSize: '26px', color: '#20252B' }}>
                {t('smsOtpVerification.screenTitle')}
              </Title>
            </Col>
            {!email && showTips && (
              <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                <Title level={3} style={{ fontSize: '20px', color: 'red' }}>
                  {t('sms.othersOtpLife')}
                </Title>
              </Col>
            )}
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Image height="176px" className="img_container" src={email ? emailIcon : mobileIcon} preview={false} />
              {/* </Space> */}
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <SubTitle
                style={{ display: 'inline-block', textAlign: 'center', fontSize: '20px', fontFamily: 'Roboto400' }}
              >
                {email ? t('smsOtpVerification.emailScreenSubtitle') : t('smsOtpVerification.mobileScreenSubtitle')}
                <br />
                {email
                  ? maskEmail(email)
                  : mobile
                  ? countryCode + '  ' + (areaCode ? `${areaCode} ` : '') + maskPhoneNumber(mobile)
                  : null}
              </SubTitle>
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <NewInput
                maxLength={6}
                value={otpArray}
                onChange={onOtpChange}
                className="single-digit-input"
                autoFocus
                ref={digit1InputRef}
                disabled={isAllowEdit}
              />
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {errorMsg && (
                <InvalidTextMsg type="danger" style={{ marginLeft: 0 }}>
                  {t(errorMsg)}
                </InvalidTextMsg>
              )}
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <ResendCaptchaSection>
                {isShowCaptcha ? (
                  <GoogleCaptcha
                    hl={i18n.language}
                    sitekey={config.captchaSiteKey}
                    onChange={onCaptchaSuccess}
                    onError={onCaptchaError}
                    onExpired={onCaptchaError}
                  />
                ) : (
                  <>
                    <Link
                      onClick={countdown > 0 ? (e) => e.preventDefault() : handleResendOtp}
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        pointerEvents: countdown > 0 ? 'none' : 'auto',
                        color: countdown > 0 ? 'gray' : '#752127', // 设置禁用时颜色为灰色
                      }}
                    >
                      {t('smsOtpVerification.resend')}
                    </Link>
                    {countdown >= 0 && (
                      <Text type="secondary" style={{ color: '#20252B', fontSize: '17px', marginTop: 20 }}>
                        {t('smsOtpVerification.resendCountdownText', {
                          second: countdown,
                        })}
                      </Text>
                    )}
                  </>
                )}
              </ResendCaptchaSection>
            </Col>

            {/* <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%' }}>
                <Button block type="primary" disabled={disabledVerification} size="large" onClick={handleVerifyOtp}>
                  {t('common.submit')}
                </Button>
              </div>
            </Col> */}
            <Link
              onClick={() => {
                navigate('/ProfileConnectLife');
              }}
              style={{
                fontSize: '17px',
                fontFamily: 'Roboto400',
                marginLeft: 4,
                marginRight: 4,
                color: '#C21B17',
                textDecoration: 'underline',
              }}
            >
              {t('common.cancel')}
            </Link>
          </Row>
        </Card>
      </div>
    </ResponsiveContainer>
  );
};
